<template>
  <div>
    <el-card header="回款业绩" id="collectRankCard">
      <div slot="header">
        <span>回款业绩</span>
        <div style="float: right">
          <router-link :to="'/ReportCollectRank'">
            <el-link type="primary">
              查看更多 <i class="el-icon-view el-icon-arrow-right"></i>
            </el-link>
          </router-link>
        </div>
      </div>
      <el-form inline :model="saleRankSearchParam">
        <el-form-item label="日期范围">
          <DateRangePicker
            :minVal.sync="saleRankSearchParam.startDate"
            :maxVal.sync="saleRankSearchParam.endDate"
            :clearable="false"
            @change="saleRankChangeAndSearch"
          ></DateRangePicker>
        </el-form-item>
        <el-form-item>
          <el-button
            icon="el-icon-search"
            type="primary"
            size="mini"
            @click="saleRankChangeAndSearch"
            :loading="saleRankLoading"
          >
            查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-popover
            placement="bottom"
            title="回款业绩统计规则"
            width="600"
            trigger="hover"
          >
            <div>
              <p>
                <span style="font-weight: bold">1. 统计范围：</span
                >审批通过、出库完成、收款完成且出库完成时间和收款完成时间的最大值在指定时间段内的销售单及销售单的实际收款金额
              </p>
              <p>
                <span style="font-weight: bold">2. 日期范围：</span
                >本周为本周周一至今日（包含本周周一及今天配送完成的单据）；本月为本月1号至今日（包含本月1号及今日的单据）；本年为本年第一天至今日（包含本年第一天及今日的单据）
              </p>
              <p>
                <span style="font-weight: bold">3. </span
                >统计用户包括单据的业务员以及所有未冻结用户，占比分析中只显示回款业绩大于
                0 的用户，更多信息请看占比分析下方的回款业绩排行
              </p>
            </div>
            <el-link
              slot="reference"
              :underline="false"
              type="info"
              icon="el-icon-question"
              >说明</el-link
            >
          </el-popover>
        </el-form-item>
      </el-form>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="balanceCol fm-center">
            <div class="balanceCol-title fm-padding-bottom-10">回款额</div>
            <el-statistic
              class="balanceCol-stat"
              :value-style="{
                'font-size': '24px',
              }"
              :value="saleRankConfig.requestResData.sumAmount"
              group-separator=","
              :precision="2"
            >
              <div slot="prefix" class="balanceCol-stat-prefix">￥</div>
            </el-statistic>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="balanceCol fm-center">
            <div class="balanceCol-title fm-padding-bottom-10">销售单数量</div>
            <el-statistic
              class="balanceCol-stat"
              :value-style="{
                'font-size': '24px',
              }"
              :value="saleRankConfig.requestResData.orderCount"
              group-separator=","
              :precision="0"
            >
            </el-statistic>
          </div>
        </el-col>
      </el-row>
      <el-table
        v-loading="saleRankLoading"
        :data="
          saleRankConfig && saleRankConfig.requestResData.itemList
            ? saleRankConfig.requestResData.itemList
            : []
        "
        stripe
        :row-key="
          (row) => {
            return row.user.id + row.amount;
          }
        "
        ref="refsTable"
        max-height="400px"
      >
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          min-width="150"
          align="left"
          header-align="center"
          sortable
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tag
              type="success"
              v-if="scope.row.user.userTypeEnum.Name == 'Boss'"
              >老板</el-tag
            >
            {{ scope.row.user.name }}
          </template>
        </el-table-column>
        <el-table-column
          prop="orderCount"
          label="单据数量"
          min-width="120"
          align="center"
          header-align="center"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="amount"
          label="销售额"
          min-width="120"
          align="center"
          header-align="center"
          sortable
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <FmAmount :amount="scope.row.amount"></FmAmount>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
  
  <script>
export default {
  name: "Fmerpv2WebSaleRankCard",

  data() {
    return {
      saleRankSearchParam: {
        startDate: null,
        endDate: null,
      },
      saleRankLoading: false,
      saleRankConfig: {
        requestResData: {
          sumAmount: 0,
          orderCount: 0,
        },
        requestSuccess: true,
        handleSuccess: false,
        data: {
          legend: [],
        },
      },
    };
  },

  mounted() {
    this.saleRankSearchParam = {
      startDate: this.$moment().startOf("week").format("yyyy-MM-DD"),
      endDate: this.$moment().format("yyyy-MM-DD"),
    };
    this.saleRankGetData();
  },

  methods: {
    saleRankChangeAndSearch() {
      this.saleRankGetData({
        showSuccessMessage: true,
      });
    },
    async saleRankGetData(args) {
      if (!this.saleRankSearchParam.startDate) {
        this.saleRankSearchParam.startDate = this.$moment()
          .startOf("week")
          .format("yyyy-MM-DD HH:mm:ss");
      }
      if (!this.saleRankSearchParam.endDate) {
        this.saleRankSearchParam.endDate = this.$moment().format(
          "yyyy-MM-DD HH:mm:ss"
        );
      }
      this.saleRankLoading = true;
      this.saleRankConfig.requestSuccess = true;
      let requestRes = await this.$api.dynamicKanban_getCollectRank(
        this.saleRankSearchParam,
        {
          showLoading: true,
          loadingParam: {
            target: "#collectRankCard",
            lock: true,
          },
          ...args,
        }
      );
      if (
        requestRes &&
        requestRes.success &&
        requestRes.data.itemList &&
        requestRes.data.itemList.length > 0
      ) {
        this.saleRankConfig.requestResData = requestRes.data;
      } else {
        this.saleRankConfig.requestSuccess = false;
      }
      setTimeout(() => {
        this.saleRankLoading = false;
      }, 200);
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.head {
  padding: 15px;
  background-color: #ffffff;
}

.balanceCol {
  background-color: #fafafd;
  padding: 10px 15px;
  border-radius: 10px;
  &-title {
    font-size: 14px;
    color: var(--fm-info-color);
  }
  &-stat {
    max-width: max-content;
    &-prefix {
      font-size: 24px;
      width: 18px;
      margin-left: -3px;
    }
    &suffix {
      font-size: 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/CollectRankCard.vue